import {
	AutocompleteInput,
	Create,
	ReferenceInput,
	SimpleForm,
	TextInput,
	required,
	useChoicesContext,
} from "react-admin";
import { unosIdValidator } from "../../validators";
import { useCreateSubmit } from "../../forms";

const PrefilledOrganSelect = () => {
	const { allChoices } = useChoicesContext();

	return (
		<AutocompleteInput
			validate={required()}
			optionText="name"
			fullWidth
			defaultValue={allChoices.length > 1 ? null : allChoices[0]?.id}
		/>
	);
};

export const MissionCreate = () => {
	const submit = useCreateSubmit("missions", "Mission created");

	return (
		<Create>
			<SimpleForm onSubmit={submit}>
				<ReferenceInput source="organ_id" reference="organs">
					<PrefilledOrganSelect />
				</ReferenceInput>
				<TextInput
					source="unos_id"
					label="UNOS ID"
					fullWidth
					validate={unosIdValidator}
				/>
				<TextInput
					source="extra_info"
					label="Additional information"
					fullWidth
				/>
			</SimpleForm>
		</Create>
	);
};
